import React from 'react'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { Box, Grid, Typography } from '@material-ui/core'
import settingsStyles from '../settingsStyles'

function AppVersion({ versionNumber, whatsNewDescription }) {
  const classes = settingsStyles()
  return (
    <Box className={classes.appVersionGrid}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
      >
        <Grid item xs container direction="column" alignItems="flex-start">
          <Typography variant="h6" className={classes.appVersionTextContainer}>
            myRutgers UXP App Version: {versionNumber}
          </Typography>
          <Typography
            variant="caption"
            className={classes.appVersionTextContainer}
          >
            UXP stands for User eXperience Platform
          </Typography>
          <Grid item container direction="row" alignItems="center">
            <Typography
              variant="h6"
              className={classes.appVersionTextContainer}
            >
              Whats New
            </Typography>
            <ArrowForwardIosIcon
              tabIndex={-1}
              classes={{ root: classes.appVersionInfoItem }}
            />
          </Grid>
          <Typography
            variant="caption"
            className={classes.appVersionTextContainer}
          >
            {whatsNewDescription}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AppVersion
